// Utilidad de ordenamiento reutilizable para los listados del panel.
// Una opción de orden es { field, type, dir }:
//   field: ruta al valor, admite anidado con puntos ('client.alias', 'local.description')
//   type:  'string' | 'number' | 'date' | 'bool'  (default 'string')
//   dir:   'asc' | 'desc'                          (default 'asc')

function ts (v) {
  if (!v) return 0
  if (typeof v.toMillis === 'function') return v.toMillis()
  if (typeof v.seconds === 'number') return v.seconds * 1000
  if (v instanceof Date) return v.getTime()
  const t = new Date(v).getTime()
  return isNaN(t) ? 0 : t
}

function getVal (obj, path) {
  if (!path) return undefined
  return path.split('.').reduce((acc, key) => (acc == null ? undefined : acc[key]), obj)
}

// Devuelve una copia ordenada de `items` según `option`.
// Si no hay opción o no tiene field, devuelve una copia sin reordenar.
export function sortItems (items, option) {
  const arr = Array.isArray(items) ? items.slice() : []
  if (!option || !option.field) return arr
  const { field, type = 'string', dir = 'asc' } = option
  const mul = dir === 'desc' ? -1 : 1
  arr.sort((a, b) => {
    const va = getVal(a, field)
    const vb = getVal(b, field)
    if (type === 'number') return mul * ((Number(va) || 0) - (Number(vb) || 0))
    if (type === 'date') return mul * (ts(va) - ts(vb))
    if (type === 'bool') return mul * ((va === vb) ? 0 : (va ? 1 : -1))
    // Normalizar: los datos traen espacios iniciales/dobles inconsistentes que
    // ensucian el orden alfabético (localeCompare sí los considera).
    const sa = String(va == null ? '' : va).trim().replace(/\s+/g, ' ')
    const sb = String(vb == null ? '' : vb).trim().replace(/\s+/g, ' ')
    return mul * sa.localeCompare(sb, 'es', { sensitivity: 'base' })
  })
  return arr
}
